import React from 'react'
import { BooleanInput, TextInput } from 'react-admin'
import { CustomFormProps } from 'types/common'
import { optionsDate } from 'services/utils/date'
import { getGeoLang } from 'services/geo-management'
import LabeledDateField from '../LabeledFields/LabeledDateField'
import CustomerFormCommon from './CustomerFormCommon'

const CustomerForm: React.FC<CustomFormProps> = ({ children, ...rest }) => (
  <CustomerFormCommon {...rest}>
    <TextInput source="email" label="form.fields.email" />

    {children}

    <TextInput source="phone" label="form.fields.responsiblePhone" />

    <TextInput source="address" label="form.fields.customerAddress" />

    <BooleanInput
      source="promotionalActivitiesConsensus"
      label="form.fields.promotionalActivitiesConsensus"
      fullWidth
    />
    <BooleanInput
      source="profilingConsensus"
      label="form.fields.profilingConsensus"
      fullWidth
    />
    <LabeledDateField
      source="createdAt"
      label="form.fields.registrationDate"
      options={optionsDate}
      locales={getGeoLang()}
    />
    <LabeledDateField
      source="lastLogin"
      label="form.fields.lastLoginDate"
      options={optionsDate}
      locales={getGeoLang()}
    />
  </CustomerFormCommon>
)

export default CustomerForm
